(() => {
  if (window.EmslandrostCheckoutDelivery) {
    window.EmslandrostCheckoutDelivery.init(document);
    return;
  }

  const marker = '[data-em-checkout-delivery-values]';
  const propertyName = 'properties[Lieferzeit]';
  const states = new WeakMap();

  function getState(form) {
    if (!form?.matches?.('form')) return null;
    const source = form.querySelector(marker);
    const input = form.querySelector('[data-em-checkout-delivery-property]');
    if (!source || !input) return null;
    const previous = states.get(form);
    if (previous?.source === source && previous.input === input) return previous;
    let values;
    try {
      values = JSON.parse(source.textContent);
    } catch {
      values = {};
    }
    if (!values || Array.isArray(values) || typeof values !== 'object') {
      values = {};
    }
    const state = { source, input, values, selectedId: undefined };
    states.set(form, state);
    return state;
  }

  function sync(form) {
    const state = getState(form);
    if (!state) return null;
    const id = form.querySelector('input[name="id"]')?.value || '';
    const matchesSelection = state.selectedId === undefined || state.selectedId === id;
    const value = matchesSelection && Object.prototype.hasOwnProperty.call(state.values, id)
      && typeof state.values[id] === 'string' ? state.values[id].trim() : '';
    // Avoid notifying app observers when the selected value has not changed.
    if (state.input.value !== value) state.input.value = value;
    if (state.input.disabled !== !value) state.input.disabled = !value;
    return state.input;
  }

  function init(scope = document) {
    const sources = [...scope.querySelectorAll(marker)];
    if (scope.matches?.(marker)) sources.push(scope);
    sources.forEach(source => sync(source.closest('form')));
  }

  function select(form, id) {
    const state = getState(form);
    if (!state) return;
    state.selectedId = id ? String(id) : '';
    sync(form);
  }

  document.addEventListener('on:variant:change', event => {
    // Enterprise supplies the exact form, including forms inside Quick Add.
    select(event.detail?.form, event.detail?.variant?.id);
  });

  document.addEventListener('change', event => {
    const picker = event.target.closest?.('variant-picker');
    if (picker && 'variant' in picker) {
      // Incomplete selections do not always emit on:variant:change.
      select(picker.productForm, picker.variant?.id);
    } else {
      const form = event.target.closest?.('form');
      if (event.target.matches?.('input[name="id"]')) {
        const state = getState(form);
        if (state) state.selectedId = event.target.value || '';
      }
      sync(form);
    }
  });

  // Synchronize before Enterprise constructs FormData or a native form submits.
  document.addEventListener('submit', event => sync(event.target), true);
  document.addEventListener('click', event => sync(event.target.closest?.('form')), true);
  document.addEventListener('formdata', event => {
    const input = sync(event.target);
    if (!input) return;
    if (input.disabled) event.formData.delete(propertyName);
    else event.formData.set(propertyName, input.value);
  }, true);

  document.addEventListener('shopify:section:load', event => init(event.target));
  // Quick Add receives a server-rendered field and is synchronized lazily by
  // the delegated variant/click/submit/formdata handlers above. No page-wide
  // observer is needed; app DOM updates must not trigger form writes.
  const start = () => init(document);
  window.EmslandrostCheckoutDelivery = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
